import { Skeleton } from '@/components/ui/skeleton';

export function ProductCardSkeleton() {
  return (
    <div className="space-y-4" data-testid="product-skeleton">
      <Skeleton className="aspect-[3/4] w-full rounded-sm bg-[#E5E5E5]" />
      <Skeleton className="h-6 w-3/4 bg-[#E5E5E5]" />
      <Skeleton className="h-4 w-1/4 bg-[#E5E5E5]" />
    </div>
  );
}

export function ProductGridSkeleton({ count = 6 }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
      {Array.from({ length: count }).map((_, i) => (
        <ProductCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function ProductDetailSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-testid="product-detail-skeleton">
      <div>
        <Skeleton className="aspect-[4/5] w-full rounded-sm bg-[#E5E5E5]" />
        <div className="flex gap-3 mt-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="w-20 h-20 rounded-sm bg-[#E5E5E5]" />
          ))}
        </div>
      </div>
      <div className="space-y-6">
        <Skeleton className="h-8 w-1/4 bg-[#E5E5E5]" />
        <Skeleton className="h-12 w-3/4 bg-[#E5E5E5]" />
        <Skeleton className="h-6 w-1/3 bg-[#E5E5E5]" />
        <div className="space-y-2 pt-4">
          <Skeleton className="h-4 w-full bg-[#E5E5E5]" />
          <Skeleton className="h-4 w-full bg-[#E5E5E5]" />
          <Skeleton className="h-4 w-2/3 bg-[#E5E5E5]" />
        </div>
      </div>
    </div>
  );
}
